<template>
  <div class="gameWrap col d-md-flex">
    <div class="col col-md-5 themePicture cursor-pointer" @click="goToStream" :style="bgStyle">
    </div>
    <div class="col col-md-7 gameInfo">
      <div class="gameTitle cursor-pointer" @click="goToStream" v-html="stream.name"></div>
      <div class="gameDescription">
        {{stream.description || 'Лига команд этой тематики. Отдельное расписание мероприятий лиги, отдельный сезонный рейтинг и тематическое оформление'}}
      </div>
      <div class="d-flex flex-column flex-row actions">
        <my-button with-margin :icon="require('../../assets/media/long_right.svg')" @click="goToStreamGames">Перейти</my-button>
      </div>
    </div>
  </div>
  
</template>

<script>
import MyButton from "../UI/MyButton";

export default {
  name: "StreamCard",
  components: { MyButton },
  props: {
    stream: {
      type: Object,
      required: true,
    }
  },
  computed: {
    bgStyle(){
      return { 'background-image': 'url('+this.stream.picture+')' }

    }
  },
  methods: {
    goToStream(){
      this.$router.push({ name: 'stream', params: { stream: this.stream.slug }})
    },
    goToStreamGames(){
      this.goToStream()
    }
  }
}
</script>

<style scoped>
.gameInfo {
  display: flex;
  flex-direction: column;
}
.actions {
  margin-top: auto;
}
.gameInfoWrapTitle {
  font-weight: 400;
  font-size: 12px;
  line-height: 100%;
  text-align: center;
  color: #FFFFFF;
  opacity: 0.6;
}
.pink {
  margin-bottom: 16px;
}
.gameDescription {
  font-weight: 400;
  font-size: 15px;
  line-height: 100%;
  text-align: center;
  color: #FFFFFF;
}
@media (min-width: 768px) {
  .pink {
    margin-right: 10px;
  }
}
</style>
